module.exports = __webpack_public_path__ + "static/media/lock_icon.f9035f16.svg";